import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { UserAvatarPipe } from '../../pipes/user-avatar.pipe';

@Component({
  selector: 'ui-avatar',
  templateUrl: './ui-avatar.component.html',
  styleUrls: ['./ui-avatar.component.scss'],
  imports: [NgIf, UserAvatarPipe],
})
export class UiAvatarComponent {
  @Input()
  public image?: string | null;

  @Input()
  public name?: string;

  @Input()
  public color?: string;

  @Input()
  public fontSize = 14;

  public onImageError(): void {
    this.image = null;
  }
}
